import type { CardAttributeDto } from "../../types/CardAttributeDto";
import type { CardAttributeEntity } from "../../types/CardAttributeEntity";

export const CardAttributeEntityToDto = ({ ...rest }: Readonly<CardAttributeEntity>): CardAttributeDto => {
    return { ...rest };
};
